<template>
  <div>
    <div class="edit-profile-dat-hld" v-if="attendeeData">
      <v-tabs v-model="currentTab" align-with-title class="sayan">
        <v-tabs-slider color="#000"></v-tabs-slider>
        <v-tab v-for="(item, index) in tabFields" :key="index">{{
          item
        }}</v-tab>
      </v-tabs>
      <v-tabs-items v-model="currentTab">
        <v-tab-item>
          <v-card flat min-height="548px" class="overflow-scroll">
            <div class="profile-image-upload-area mt-3">
              <input
                id="profileImage"
                type="file"
                @change="onProfileChange"
                ref="file"
                style="display: none"
                accept="image/*"
              />
              <div class="uploaded-image" v-if="attendeeData.ProfilePictureURL">
                <img :src="attendeeData.ProfilePictureURL" />
              </div>
              <div class="uploaded-image" v-else>
                <img src="../assets/Images/default-avtar.png" />
              </div>
              <!-- <input
                type="text"
              class="image-link-txt mb-2"
              /> -->

              <div class="gender-btn-wrapper-hld mt-3">
                <v-btn
                  outlined
                  color="#000"
                  height="50"
                  large
                  class="full-width"
                  @click="openSelfiePopup()"
                >
                  Take a Selfie
                </v-btn>
                <div
                  class="
                    btn-group
                    d-flex
                    align-items-center
                    justify-content-between
                    mt-3
                  "
                >
                  <v-btn
                    outlined
                    color="#000"
                    height="50"
                    large
                    class="full-width"
                    v-on:click="openUpload"
                  >
                    Upload
                  </v-btn>
                </div>
              </div>
            </div>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat min-height="548px" class="overflow-scroll">
            <div class="information-details-hld">
              <p>(<span>*</span>) Marked fields are mandatory to Complete</p>
              <h5>Basic Information</h5>
              <v-row>
                <v-col md="12" sm="12">
                  <div class="salutation-wrap">
                    <label>Salutation</label>
                    <select
                      v-if="SalutationOptions.length"
                      v-model="attendeeData.Salutation"
                    >
                      <option
                        v-for="(option, index) in SalutationOptions"
                        :key="index"
                        :value="option"
                      >
                        {{ option }}
                      </option>
                    </select>
                    <input
                      v-else
                      type="text"
                      v-model="attendeeData.Salutation"
                    />
                  </div>
                </v-col>
                <v-col md="6" sm="12">
                  <label>First Name <span class="text-danger">*</span></label>
                  <input type="text" v-model="attendeeData.FirstName" />
                </v-col>
                <v-col md="6" sm="12">
                  <label>Last Name <span class="text-danger">*</span></label>
                  <input type="text" v-model="attendeeData.LastName" />
                </v-col>
                <v-col md="6" sm="12">
                  <div class="no-edit-filed">
                    <label>Email</label>
                    <input
                      type="text"
                      disabled
                      readonly
                      v-model="attendeeData.Email"
                    />
                  </div>
                </v-col>
                <v-col md="6" sm="12">
                  <label>Mobile</label>
                  <VuePhoneNumberInput
                    :error-color="errorColor"
                    :default-country-code="attendeeData.PhoneCountryCode"
                    v-model="attendeeData.Phone"
                    name="Phone"
                    class="w-full"
                    :preferredCountries="['US', 'GB', 'SG', 'IN']"
                    @update="setPhoneCode"
                  />
                  <!-- <input type="text" v-model="attendeeData.Phone" /> -->
                  <span v-if="PhoneNumberError" class="text-danger">{{
                    PhoneNumberError
                  }}</span>
                </v-col>
                <v-col md="6" sm="12">
                  <label>Company</label>
                  <input type="text" v-model="attendeeData.Company" />
                </v-col>
                <v-col md="6" sm="12">
                  <label>Designation</label>
                  <input type="text" v-model="attendeeData.Designation" />
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat min-height="548px" class="overflow-scroll">
            <div class="information-details-hld">
              <p>(<span>*</span>) Marked fields are mandatory to Complete</p>
              <h5>Postal Address Information</h5>
              <v-row class="my-0">
                <v-col md="12" sm="12">
                  <label>Mailing Address</label>
                  <textarea
                    cols="12"
                    rows="5"
                    v-model="attendeeData.Address"
                  ></textarea>
                </v-col>
                <v-col md="6" sm="12">
                  <div class="salutation-wrap">
                    <label>Country</label>
                    <!-- <input type="text" v-model="attendeeData.Country" /> -->
                    <select
                      v-model="attendeeData.Country"
                      @change="setStates()"
                    >
                      <option value="">Select Country</option>
                      <option
                        v-for="(optionval, oindex) in Countries"
                        :key="oindex"
                        :value="optionval.country"
                      >
                        {{ optionval.country }}
                      </option>
                    </select>
                  </div>
                </v-col>
                <v-col md="6" sm="12">
                  <div class="salutation-wrap">
                    <label>State</label>
                    <!-- <input type="text" v-model="attendeeData.State" /> -->
                    <select name="State" v-model="attendeeData.State">
                      <option value="">Select State</option>
                      <option
                        v-for="(optionval, oindex) in States"
                        :key="oindex"
                        :value="optionval"
                      >
                        {{ optionval }}
                      </option>
                    </select>
                  </div>
                </v-col>
                <v-col md="6" sm="12">
                  <label>City</label>
                  <input type="text" v-model="attendeeData.City" />
                </v-col>
                <v-col md="6" sm="12">
                  <label>Zip</label>
                  <input type="text" v-model="attendeeData.Zip" />
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat min-height="548px" class="overflow-scroll">
            <div class="information-details-hld">
              <p>(<span>*</span>) Marked fields are mandatory to Complete</p>

              <h5 class="mt-4">Mini Bio</h5>
              <textarea
                cols="12"
                rows="5"
                v-model="attendeeData.Profile"
              ></textarea>

              <h5 class="mt-8">Category &amp; Keywords</h5>

              <div class="show-category-box">
                <input-tag
                  class=""
                  placeholder="Add multiple keywords separated by comma. eg: marketing, branding, technology"
                  v-model="attendeeData.Tags"
                ></input-tag>
              </div>
            </div>
          </v-card>
        </v-tab-item>

        <v-tab-item v-if="DynamicFields.length">
          <v-card flat min-height="548px" class="overflow-scroll">
            <div class="information-details-hld">
              <p>(<span>*</span>) Marked fields are mandatory to Complete</p>
              <h5>Dynamic Fields</h5>
              <v-row class="my-0">
                <v-col
                  v-for="(field, index) in DynamicFields"
                  :key="index"
                  :md="field.ColumnSize"
                  sm="12"
                >
                  <label>{{ field.Label }}</label>
                  <textarea
                    v-if="field.Type == 'textarea'"
                    v-model="DynamicFields[index].value"
                    cols="12"
                    rows="5"
                  ></textarea>
                  <select
                    v-else-if="['select', 'multiselect'].includes(field.Type)"
                    v-model="DynamicFields[index].value"
                  >
                    <option
                      v-for="(option, oindex) in field.Options"
                      :key="oindex"
                      :value="option"
                    >
                      {{ option }}
                    </option>
                  </select>
                  <span v-else-if="field.Type == 'radio'">
                    <input
                      class="mr-2"
                      type="radio"
                      v-for="(option, oindex) in field.Options"
                      :key="oindex"
                      v-model="DynamicFields[index].value"
                      :name="field.Name"
                      :value="option"
                    />{{ option }}
                  </span>
                  <input
                    v-else
                    :type="field.Type"
                    v-model="DynamicFields[index].value"
                  />
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </div>

    <div class="d-flex justify-content-end align-items-center mt-1">
      <v-btn
        color="#6b6b6b"
        data-tag="profileEdit"
        tabindex="3"
        outlined
        class="mr-2"
        @click="$emit('closePopup')"
      >
        Cancel
      </v-btn>
      <v-btn
        depressed
        color="#1a73e8"
        href="#"
        data-tag="profileEdit"
        tabindex="3"
        @click="saveUserDetails()"
      >
        {{
          currentTab + 1 == tabFields.length
            ? "Save &amp; Exit"
            : "Save &amp; Next"
        }}
      </v-btn>
    </div>
  </div>
</template>

<script>
// import router from "../router";
// import common from "../common.ts";
import store from "../store";
import firebase from "firebase";
import db from "../components/firebaseInit";
import InputTag from "vue-input-tag";
const storage = firebase.storage();
const storageRef = storage.ref();
// import analytics from "@/components/Analytics";
import APIs from "@/components/APIInit";
import jQuery from "jquery";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
// import https from "https";

import axios from "axios";
import { bus } from "@/main";

let $ = jQuery;
//const storageRef = firebase;
var obj = JSON.parse(window.localStorage.getItem("my-app"));
// var vm;
export default {
  components: { InputTag, VuePhoneNumberInput },
  data() {
    return {
      currentTab: 0,
      tabFields: [
        "Setup Profile Picture",
        "Basic Information",
        "Postal Address",
        "Bio & Keywords",
      ], //'Profile Image'
      attendeeData: null,
      SalutationOptions: ["Dr.", "Ms.", "Mrs.", "Mr."],
      DynamicFields: [],
      PreDefinedFields: [],
      StaticFields: [],
      file: null,
      Countries: [],
      States: [],
      PhoneNumberError: null,
      errorColor: "#ff0000",
    };
  },
  computed: {},
  mounted() {
    //console.log(Intl.DateTimeFormat().resolvedOptions().timeZone)
    //console.log(this.$route.name)
  },
  async created() {
    await this.getCountries();
    this.getAttendeeDetail();
    bus.$on("sendSelfieImage", (blob, blobUrl) => {
      var file = new File([blob], "selfie_" + new Date().getTime() + ".png", {
        type: "image/png",
        lastModified: new Date().getTime(),
      });
      this.file = file;
      console.log("file>>>>>>", file);
      console.log("blobUrl>>>>>>", blobUrl);

      this.onProfileChange(null, true, file);

      //console.log("previewFileUrl>>>>>>", self.previewFileUrl);
    });
  },
  destroyed() {
    this.attendeeData = null;
  },
  methods: {
    openSelfiePopup() {
      bus.$emit("openSelfiePopup", false);
    },
    openUpload() {
      $("#profileImage").trigger("click");
    },
    onProfileChange(e, isSelfie, selfieFile) {
      var self = this;
      var files;
      var file;
      //var obj = JSON.parse(window.localStorage.getItem("my-app"));
      debugger;
      if (isSelfie == undefined) {
        files = e.target.files || e.dataTransfer.files;
        if (!files.length) return;
        for (var i = 0; i < files.length; i++) {
          file = files[i];
          const fileSize = file.size / 1024 / 1024;
          if (fileSize > 15) {
            alert("File size exceeds 15 MB");
            return;
          }
        }
      } else {
        file = selfieFile;
      }
      var metadata = {
        contentType: file.type,
      };

      const validImageTypes = ["image/gif", "image/jpeg", "image/png"];
      if (!validImageTypes.includes(file.type)) {
        // invalid file type code goes here.
        alert("Only gif,jpeg & png file allowed.");
        return false;
      }
      bus.$emit("toggleLoader", true);

      //$(".loader-profile").addClass("show");

      storage
        .ref()
        .child(
          obj.eventcollectionname +
            "/Attendees/" +
            self.attendeeData.AttendeeId +
            "_" +
            new Date().getTime() +
            "_" +
            file.name
        )
        .put(file, metadata)
        .then(function (snapshot) {
          snapshot.ref
            .getDownloadURL()
            .then(function (imgURL) {
              self.attendeeData.ProfilePictureURL = imgURL;
              bus.$emit("toggleLoader", false);
            })
            .then(() => {
              console.log("Successfully updated the record");
            })
            .catch((error) => {
              console.error("There was an error editing the record: " + error);
            });
        })
        .catch(function (error) {
          console.error("Upload failed:", error);
        });
    },
    getDefaultCountry() {
      return new Promise((resolve, reject) => {
        axios
          .get(
            "https://api.geoapify.com/v1/ipinfo?apiKey=37a6bcd1c1184615a858b3ad499aa89c"
          )
          .then((res) => {
            //self.CountryName = res.data.country.name;
            //this.attendeeData.PhoneCountryCode = res.data.country.iso_code;
            resolve(res.data.country);
          })
          .catch((error) => {
            reject("There was an error to read client branding: " + error);
          });
      });
    },
    getCountries() {
      return new Promise((resolve, reject) => {
        axios
          .get(
            "https://resources.e2m.live/e2monair.appspot.com/OA_UAT/Defaults/CountryState.json"
          )
          .then((res) => {
            if (res.status == 200) this.Countries = res.data.countries;
            resolve(true);
          })
          .catch((err) => reject(err));
      });
    },
    setStates() {
      let country = this.attendeeData.Country;
      //console.log(typeof country)

      if (country && typeof country == "object")
        this.States = country.states ? country.states : [];
      else if (typeof country == "string") {
        this.Countries.map((item) => {
          if (item.country == country)
            this.States = item.states ? item.states : [];
        });
      }
    },
    setPhoneCode(data) {
      //console.log(data)
      this.PhoneNumberError = null;
      if (data && data.isValid && data.formattedNumber) {
        this.attendeeData.Phone = data.nationalNumber;
        this.attendeeData.PhoneCountryCode = data.countryCode;
      } else if (data.nationalNumber) {
        this.PhoneNumberError = "Enter valid number!";
      }
    },
    async getAttendeeDetail() {
      bus.$emit("toggleLoader", true);
      let Apath = obj.eventcollectionname + "/AttendeeList/Attendees";
      let doc = await db.collection(Apath).doc(obj.user[0].id).get().catch();
      if (doc.exists) {
        this.attendeeData = doc.data();
        this.setStates();
      }
      bus.$emit("toggleLoader", false);
      if (!this.attendeeData || !this.attendeeData.RegistrationType)
        return false;

      if (
        !this.attendeeData.PhoneCountryCode ||
        this.attendeeData.PhoneCountryCode == ""
      ) {
        this.getDefaultCountry().then((country) => {
          this.attendeeData.PhoneCountryCode = country.iso_code;
        });
      }
      let ARegistrationType =
        typeof this.attendeeData.RegistrationType == "string"
          ? this.attendeeData.RegistrationType
          : this.attendeeData.RegistrationType.RegistrationType;
      //let Rpath = obj.eventcollectionname + "/FormList/CheckoutForms";
      let Rpath = storageRef.child(
        obj.eventcollectionname + "/Registration/CheckoutForms.JSON"
      );
      //let rquerySnaps = await db.collection(Rpath).get().catch();
      let RURL = await Rpath.getDownloadURL().catch();
      let response = await axios.get(RURL).catch();
      let checkoutForm = null;
      for (let form of response.data.CheckoutForms) {
        let regTypeFound = form.RegistrationTypes.some(
          (item) => item.RegistrationType == ARegistrationType
        );
        if (regTypeFound) {
          checkoutForm = form;
        }
      }
      if (checkoutForm && checkoutForm.DefaultFields) {
        this.DynamicFields = checkoutForm.DefaultFields.filter((item) => {
          if (!item.StaticField && !item.IsPredefined) {
            let field = null;
            if (this.attendeeData.DynamicFields)
              field = this.attendeeData.DynamicFields.find(
                (ditem) => ditem.Name == item.Name
              );
            item.value = field && field.Value ? field.Value : null;
            return true;
          } else {
            return false;
          }
        });
      }

      if (this.DynamicFields.length) this.tabFields.push("Additional Info");
      this.PreDefinedFields = checkoutForm.DefaultFields.filter(
        (item) => item.IsPredefined
      );
      this.StaticFields = checkoutForm.DefaultFields.filter(
        (item) => item.StaticField
      );
      this.PreDefinedFields.forEach((item) => {
        if (item.Name == "Salutation" && item.Options && item.Options.length)
          this.SalutationOptions = item.Options;
      });
    },
    validateForm() {
      if (this.currentTab == 1) {
        if (!this.attendeeData.FirstName) {
          this.showSnackbar("Enter First Name please!", "error", "top");
          return false;
        } else if (!this.attendeeData.LastName) {
          this.showSnackbar("Enter Last Name please!", "error", "top");
          return false;
        } else return true;
      } else {
        return true;
      }
    },
    saveUserDetails() {
      if (!this.validateForm()) return false;
      bus.$emit("toggleLoader", true);
      let attendeeData = {
        Designation: this.attendeeData.Designation,
        PhoneCountryCode: this.attendeeData.PhoneCountryCode,
        Country: this.attendeeData.Country ? this.attendeeData.Country : null,
        Name:
          this.attendeeData.FirstName.trim() +
          " " +
          this.attendeeData.LastName.trim(),
        LastName: this.attendeeData.LastName.trim(),
        Salutation: this.attendeeData.Salutation,
        FirstName: this.attendeeData.FirstName.trim(),
        State: this.attendeeData.State,
        Phone: this.attendeeData.Phone,
        Company: this.attendeeData.Company,
        Address: this.attendeeData.Address,
        City: this.attendeeData.City,
        Tags: this.attendeeData.Tags,
        Zip: this.attendeeData.Zip,
        UserId: this.attendeeData.AttendeeId,
        ProfilePictureURL: this.attendeeData.ProfilePictureURL,
        Profile: this.attendeeData.Profile,
      };
      attendeeData.DynamicFields = this.DynamicFields.map((item) => {
        return {
          Label: item.Label,
          Name: item.Name,
          Value: item.value,
        };
      });

      let headers = {
        Authorization: "Bearer " + this.getSessionToken(),
        "content-type": "application/json",
      };
      let requestData = {
        key: {
          clientId: this.$store.state.client[0].id,
          eventId: this.$store.state.eventid,
          instanceId: "OA_UAT",
        },
        data: attendeeData,
      };

      axios
        .post(APIs.UpdateSingleAttendee, requestData, { headers: headers })
        .then((response) => {
          if (response.data.status == 0) {
            bus.$emit("toggleLoader", false);
            this.showSnackbar("Data updated successfully.");
            //this.$emit('closePopup')
          } else {
            bus.$emit("toggleLoader", false);
            this.showSnackbar("Unable to update data!");
            //this.$emit('closePopup')
          }
          if (this.currentTab + 1 == this.tabFields.length)
            this.$emit("closePopup");
          else this.currentTab++;
          this.saveLocalData(attendeeData);
        })
        .catch(() => {
          bus.$emit("toggleLoader", false);
          this.showSnackbar("Something went wrong!");
          //this.$emit('closePopup')
        });
    },
    saveLocalData(attendeeData) {
      // if(this.currentTab == 0){
      //   store.commit("addUser", {
      //     id: obj.user[0].id,
      //     profilepic: attendeeData.ProfilePictureURL
      //   });
      // }else if(this.currentTab == 1){
      store.commit("addUser", {
        id: obj.user[0].id,
        Email: obj.user[0].Email,
        salutation: attendeeData.Salutation,
        name: attendeeData.Name ? attendeeData.Name.trim() : "",
        fname: attendeeData.FirstName ? attendeeData.FirstName.trim() : "",
        lname: attendeeData.LastName ? attendeeData.LastName.trim() : "",
        profilepic: attendeeData.ProfilePictureURL,
        company: attendeeData.Company,
        title: attendeeData.Designation,
        phone: attendeeData.Phone,
      });
      //}
      let functionName = null;
      if (this.$route.name == "MyProfileV2") functionName = "myProfileFunction";
      setTimeout(() => this.$emit("editProfileSuccess", functionName), 1000);
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800;900&family=Titan+One&display=swap");

.profile-input-section-popup input[type="text"],
.profile-input-section-popup input[type="number"],
.profile-input-section-popup select {
  height: 42px;
  width: 100%;
  border: 1px solid #dfdfdf;
  border-radius: 5px;
  padding: 0 15px;
  font-size: 16px;
  color: #000;
}

.centerText {
  display: flex;
  justify-content: center;
}

.profile-wrapper-des-right {
  background: #fff;
  padding: 10px 15px;
}

.profile-wrapper-des-right .card {
  box-shadow: none !important;
  border: none !important;
  background: none !important;
}

#attendeeProfile.attendee-details-popup {
  display: flex;
}

.profile-wrapper-des-right,
.my-profile .attendee-list .sponsors-box-hld {
  height: 100% !important;
}

.my-profile .top-img-box {
  padding: 30px 0 !important;
}

.profile-wrapper-des-right {
  border-radius: 0 5px 5px 0;
  box-shadow: 0 0 8px 0px rgba(0, 0, 0, 0.1);
}

.my-profile .attendee-list .sponsors-box-hld {
  box-shadow: none;
  border: none;
  border-radius: 5px 0 0 5px;
}

.col-md-4.prof {
  padding-right: 0;
}

.my-profile .attendee-img-area.loading:after {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  content: "";
  border-radius: 50%;
  z-index: 2;
}

.my-profile .attendee-img-area .edit_ico {
  background: #cc1022;
  border: 3px solid #fff;
  width: 40px;
  height: 40px;
  z-index: 3;
}

.title-line {
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
}

p#AttEmail {
  text-align: center;
}

.showEdit p#AttEmail[data-text="Email"] {
  text-align: left;
}

p#AttCountry,
p#AttPhone {
  text-align: center;
}

.title-line {
  letter-spacing: 0.5px;
}

.title-line h4 {
  margin: 0 !important;
  font-size: 16px !important;
  color: #858585;
}

.title-line p {
  font-size: 16px !important;
  color: #858585;
  padding-left: 4px !important;
}

.my-profile .sponsors-box-hld h3 {
  margin: 18px 10px 6px;
  font-size: 24px;
}

.blue-button:hover,
.blue-button:focus,
.blue-button {
  background: #cc1022;
  text-transform: uppercase;
  padding: 12px 30px !important;
  height: auto !important;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 1px;
  border: 2px solid #cc1022;
}

.edit-icon {
  display: flex;
  flex-direction: row-reverse;
}

.edit-icon .edit_ico {
  background: none;
}

.edit-panel-cvr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  padding: 0px 0 12px 0;
}

.profile-wrapper-des-right p#AttProfile {
  padding: 10px;
  border: 1px solid rgba(0, 0, 0, 0);
  max-height: 20vh;
  overflow: auto;
  text-align: justify;
}

.profile-wrapper-des-right p#AttProfile[contenteditable="true"] {
  border: 1px solid #ddd;
}

.bni-cat p {
  display: block;
  width: 100%;
}

.bni-cat p input#txtTags {
  border: 1px solid #ddd;
  width: 100%;
  padding: 10px 15px;
  height: 47px;
  margin-top: 5px;
  color: #969696;
}

.tag-bni-list {
  margin: 10px 0;
  margin-bottom: 30px;
}

.tag-bni-list span.badge {
  padding: 10px 10px 10px 15px;
  background: #f0f2f7;
  color: #353535;
  text-transform: capitalize;
  font-size: 14px;
  letter-spacing: 0.5px;
  border-radius: 20px;
  font-weight: 300;
}

.tag-bni-list span.badge button {
  color: #545454;
}

.socialLinkProf a[href=""] {
  display: none;
}

.showEdit#profileSocial .socialLinkProf ul li span a {
  display: block;
  width: 100%;
  padding: 0;
  border: none;
  height: auto;
}

.attendee-list .sponsors-box-hld h4:empty + span {
  display: none;
}

.blue-button.btn-cancel.edit-cancel {
  background: transparent !important;
  color: #cc1022;
  border: 2px solid #cc1022;
}

.blue-button.btn-cancel.edit-cancel,
.blue-button.ml-2.edit-save {
  width: 100px !important;
  min-width: 1px !important;
  text-align: center;
}

@keyframes popTopUp {
  0% {
    transform: translateY(10px);
  }

  100% {
    transform: translateY(0);
  }
}

.info-alert-msg {
  position: fixed;
  right: 0;
  left: 0;
  margin: auto;
  bottom: 30px;
  background: rgba(0, 0, 0, 0.85);
  color: #fff;
  padding: 15px 15px;
  letter-spacing: 1px;
  font-size: 14px;
  border-radius: 5px;
  display: none;
  max-width: 300px;
  text-align: center;
}

.info-alert-msg.show {
  animation: popTopUp 0.5s linear;
}

.btn.btn-LinkedIn {
  position: absolute;
  right: 15px;
  background: #003f67;
  top: 18px;
  color: #fff;
  padding: 7px 13px;
  padding-left: 50px;
  font-size: 14px;
}

.btn.btn-LinkedIn svg {
  position: absolute;
  left: 7px;
  top: 4px;
  width: 26px;
  height: 26px;
}

.btn.btn-LinkedIn:after {
  position: absolute;
  left: 40px;
  top: 0;
  bottom: 0;
  content: "";
  width: 1px;
  background: #082a40;
}

.loader-profile {
  position: fixed;
  right: 0px;
  top: 0px;
  left: 0;
  bottom: 0;
  z-index: 30001;
  opacity: 1;
  transform: scale(2);
  justify-content: center;
  align-items: center;
  transition: all 0.5s ease;
  display: none;
}

.loader-profile.show {
  display: flex;
}

[contentEditable="true"]:empty:not(:focus):before {
  content: attr(data-text);
}

.socialLinkProf {
  margin: 10px 0 0 0;
}

.socialLinkProf a {
  width: 40px;
  height: 40px;
  border: 1px solid #ddd;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.socialLinkProf a svg {
  fill: #000000;
}

p.prof-website {
  display: block;
  text-align: center;
  margin-top: 12px;
  margin-top: 0 !important;
}

p.prof-website img {
  width: 33px;
  display: inline-block;
  vertical-align: middle;
}

p.prof-website a {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: calc(100% - 50px);
  vertical-align: middle;
  padding-left: 8px;
  font-size: 17px;
  color: #000;
}

.socialLinkProf a span {
  display: none;
}

.socialLinkProf ul {
  display: flex;
  margin: 0 !important;
  padding: 0 !important;
  justify-content: center;
  align-items: center;
}

.profile-hld-box.showEdit .socialLinkProf ul {
  display: block;
}

.socialLinkProf ul li {
  display: inline-block;
  margin: 5px 5px 0;
}

.socialLinkProf ul li:focus {
  border-color: transparent;
}

.socialLinkProf ul li span {
  display: none;
}

#attendeeProfile.attendee-details-popup {
  height: auto;
  width: auto;
  max-width: none;
  max-height: none;
}

.attendee-first-last-name {
  display: none;
}

.profile-edit-box {
  display: none;
  width: 100%;
  border: none;
  height: 42px;
  padding: 0 0;
  border-bottom: 1px solid #ddd;
}

.prof-website .profile-edit-box {
  border: none;
  padding: 0 8px;
}

.socialLinkProf .profile-edit-box {
  border: none;
  padding: 0 8px;
}

.showEdit#profileSocial .profile-edit-box {
  display: block;
}

.showEdit#profileSocial .attendee-first-last-name {
  display: block;
  text-align: left;
  margin: 18px 0 0;
}

.showEdit#profileSocial .attendee-first-last-name h3 {
  display: inline;
  margin: 0;
  border: none;
}

.showEdit#profileSocial .attendee-first-last-name h3 + h3 {
  padding-left: 7px !important;
}

.showEdit#profileSocial .full-name {
  display: none;
}

.showEdit#profileSocial p#AttProfile[contenteditable="true"],
.showEdit#profileSocial.sponsors-box-hld h4[contenteditable="true"],
.showEdit#profileSocial p#Attcompany[contenteditable="true"],
.my-profile
  .showEdit#profileSocial.sponsors-box-hld
  h3[contenteditable="true"][contenteditable="true"] {
  padding: 10px 0;
  text-align: left;
}

.showEdit .title-line {
  display: block;
}

.showEdit#profileSocial .comma {
  display: none;
}

.showEdit#profileSocial .title-line p {
  padding-left: 0 !important;
}

.showEdit#profileSocial .socialLinkProf {
  margin: 0;
}

.showEdit#profileSocial .socialLinkProf ul li {
  display: flex;
  margin: 0;
  border-bottom: 1px solid #ddd;
  padding: 0 0;
}

.showEdit#profileSocial .socialLinkProf a {
  display: inline-flex;
  width: 30px;
  height: 30px;
}

.showEdit#profileSocial .socialLinkProf ul li span {
  display: inline-flex;
  width: calc(100% - 44px);
  height: 30px;
  padding: 4px 10px;
  overflow: hidden;
}

.showEdit#profileSocial .socialLinkProf ul li span * {
  white-space: nowrap;
  padding: 0;
  text-align: left;
}

.showEdit#profileSocial p.prof-website {
  display: flex;
  align-items: center;
  margin: 0 !important;
  border-bottom: 1px solid #ddd;
}

.showEdit#profileSocial p.prof-website svg {
  width: 30px;
  height: 27px;
  margin: 0 1px 0 3px;
}

.my-profile .showEdit#profileSocial.sponsors-box-hld h3 {
  margin-left: 0;
  margin-right: 0;
}

.showEdit#profileSocial p.prof-website a {
  width: calc(100% - 44px);
  text-align: left;
  color: #5d5c5c;
  font-size: 14px;
  padding-left: 19px;
}

.showEdit#profileSocial p.prof-website a,
.showEdit#profileSocial .socialLinkProf ul li span:focus {
  border-color: transparent;
  outline: none;
}

.showEdit#profileSocial #Attcompany,
.showEdit#profileSocial #AttName_first,
.showEdit#profileSocial #AttName_last,
.showEdit#profileSocial #Attcompany,
.showEdit#profileSocial #Attfacebook,
.showEdit#profileSocial #Atttwitter,
.showEdit#profileSocial #Attlinkedin,
.showEdit#profileSocial #Atttitle,
.showEdit#profileSocial #Attwebsite {
  display: none;
}

.showEdit#profileSocial .title-line p {
  text-align: left !important;
}

.showEdit .title-line {
  margin-bottom: 20px;
}

.profile-booth-image {
  width: 200px;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #cbcbcb;
  overflow: hidden;
  border-radius: 5px;
  margin-right: 15px;
}

h4.profile-boothname {
  font-size: 20px;
  color: #000;
  margin-bottom: 5px !important;
  font-weight: 400;
}

p.profile-booth-desc {
  margin-bottom: 0 !important;
  color: #000;
  font-weight: 400;
  font-size: 16px;
  line-height: 21px;
}

.profile-booth-list .v-list-item {
  border: 1px solid #cbcbcb;
  padding: 15px;
  border-radius: 5px;
  margin: 5px 0;
}

.profile-booth-list .v-list {
  padding: 0 !important;
}

.profile-booth-list {
  height: 476px;
  overflow-y: auto;
}

.profile-switch-wrap {
  box-shadow: rgb(0 0 0 / 10%) 0px 0.0625rem 0.125rem,
    rgb(0 0 0 / 15%) 0px 0.25rem 1rem -0.125rem;
  padding: 15px;
  border-radius: 10px;
  height: 100%;
}

.title-line p#AttEmail {
  font-size: 12px !important;
  word-break: break-word;
}

.profile-hld-box {
  border-radius: 10px !important;
}

.update-prof-button {
  background: #1976d2;
  padding: 8px 0;
  border-radius: 4px;
}

.profile-switch-wrap .v-tab {
  font-size: 15px;
  color: #000 !important;
}

.profile-switch-wrap .v-tabs-slider-wrapper {
  height: 3px !important;
  color: #000;
}

.keywords-add-button {
  width: 120px;
  height: 47px;
  background: #2876e5 !important;
  font-size: 16px;
  color: #fff;
  font-weight: 600;
  text-transform: uppercase;
  border-radius: 5px;
  margin-top: 3px;
}

button.submit-button {
  color: #ffffff !important;
  font-size: 14px !important;
  font-weight: 600;
}

@media only screen and (max-width: 767px) {
  .attendee-list .sponsors-box-hld .grey-bg-texthld {
    width: auto;
  }

  p#Attcompany {
    text-align: center;
  }

  .sponsors-box-hld p.edit-btn-set {
    margin-top: 20px;
  }

  .attendee-list .sponsors-box-hld span.attendee-img-area {
    overflow: visible;
    max-height: 140px;
    max-width: 140px;
  }

  .profile-wrapper-des-right {
    border-radius: 5px;
    padding: 0 10px;
  }

  .my-profile .attendee-list .sponsors-box-hld {
    border-radius: 5px;
  }

  .profile-wrapper-des-right,
  .my-profile .top-img-box {
    padding: 10px 14px !important;
  }
}

@media only screen and (max-width: 580px) {
  .d-flex.bni-cat {
    flex-direction: column;
  }
}

@media only screen and (max-width: 480px) {
  .d-flex.bni-cat {
    flex-direction: column;
  }

  .btn.btn-LinkedIn {
    width: 200px;
    position: relative;
    top: 0;
    right: 0;
    margin: auto;
  }

  .profile-wrapper-des-right p#AttProfile {
    padding-left: 0;
  }

  .edit-panel-cvr {
    margin-top: 10px;
  }

  .my-profile .sponsors-box-hld h3 {
    font-size: 20px;
  }

  .profile-wrapper-des-right h5 {
    text-align: center;
  }
}
</style><style scoped>
.v-application a {
  color: white;
}
</style>
